/* AA collection title dropdown — toggles the branch panel.
   Relocates the panel to <body> (the facet bar has backdrop-filter on desktop, a
   backdrop-root that would trap the fixed panel + flatten it). Desktop flies in from
   the left; mobile flies up from the bottom, starting just below the facet bar. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.aaColtbInit) return;
    root.dataset.aaColtbInit = 'true';

    var toggle = root.querySelector('[data-aa-coltb-toggle]');
    var panel = root.querySelector('[data-aa-coltb-panel]');
    var veil = root.querySelector('[data-aa-coltb-veil]');
    if (!toggle || !panel) return;

    document.body.appendChild(panel);
    if (veil) document.body.appendChild(veil);

    function open() {
      // On mobile the panel starts just below the facet bar so the title stays visible.
      // Measure the bar's real bottom and floor it — a fractional getBoundingClientRect
      // (e.g. 163.4px) left a 1-2px sliver of the grid uncovered above the panel. Floor
      // guarantees the panel top sits at/above the grid top (no gap), and reading it live
      // also tracks the sticky bar's position when the page is scrolled.
      if (window.innerWidth < 750) {
        var bar = root.closest('.facets-container') ||
          document.querySelector('.template-collection .facets-container');
        var topPx = 165;
        if (bar) {
          var b = bar.getBoundingClientRect().bottom;
          if (b > 0) topPx = Math.floor(b);
        }
        panel.style.top = topPx + 'px';
      } else {
        panel.style.top = '';
      }
      root.classList.add('is-open');
      panel.classList.add('is-open');
      if (veil) veil.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onKey);
      document.addEventListener('click', onDoc, true);
    }

    function close() {
      root.classList.remove('is-open');
      panel.classList.remove('is-open');
      if (veil) veil.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('click', onDoc, true);
    }

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') close();
    }

    // Close on any click outside the panel and the toggle.
    function onDoc(e) {
      if (panel.contains(e.target) || toggle.contains(e.target)) return;
      close();
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (root.classList.contains('is-open')) close();
      else open();
    });

    panel.querySelectorAll('[data-aa-coltb-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    // A link click navigates away; close so it's tidy on back-nav.
    panel.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', close);
    });

    // "View Main Menu" button: close this dropdown and open the main mega menu (its burger).
    panel.querySelectorAll('[data-aa-open-main-menu]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        close();
        var megaBurger = document.querySelector('[data-aa-mega-open]');
        if (megaBurger) megaBurger.click();
      });
    });

    window.addEventListener('resize', function () {
      if (root.classList.contains('is-open')) close();
    });

    // Mobile: drag/swipe the panel down to close (the black-line handle is the
    // affordance). Only starts from the top of the panel's scroll (or the handle),
    // so normal content scrolling still works.
    var dragStartY = null;
    var dragging = false;
    panel.addEventListener('touchstart', function (e) {
      if (window.innerWidth >= 750) return;
      var onHandle = e.target.closest('.aa-coltb__handle');
      if (!onHandle && panel.scrollTop > 0) return;
      dragStartY = e.touches[0].clientY;
      dragging = false;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (dragStartY === null) return;
      var dy = e.touches[0].clientY - dragStartY;
      if (dy <= 0) { dragStartY = null; return; } // upward → let it scroll
      dragging = true;
      e.preventDefault(); // hold the page still while dragging down
      panel.style.transition = 'none';
      panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: false });
    panel.addEventListener('touchend', function (e) {
      if (dragStartY === null) return;
      var endY = (e.changedTouches && e.changedTouches[0].clientY) || dragStartY;
      var dy = endY - dragStartY;
      panel.style.transition = '';
      panel.style.transform = '';
      dragStartY = null;
      var wasDragging = dragging;
      dragging = false;
      if (wasDragging && dy > 90) close();
    });
  }

  function boot() {
    document.querySelectorAll('aa-collection-dropdown').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
